import React from 'react';

const DaoIcon = (props?: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.93877 3.73125C2.14502 4.78125 1.67627 6.0875 1.67627 7.5C1.67627 10.95 4.47627 13.75 7.92627 13.75C11.3763 13.75 14.1763 10.95 14.1763 7.5C14.1763 4.05 11.3763 1.25 7.92627 1.25"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.55127 7.5C3.55127 9.91875 5.50752 11.875 7.92627 11.875C10.345 11.875 12.3013 9.91875 12.3013 7.5C12.3013 5.08125 10.345 3.125 7.92627 3.125"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.92627 10C9.30752 10 10.4263 8.88125 10.4263 7.5C10.4263 6.11875 9.30752 5 7.92627 5"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DaoIcon;
